export default __webpack_public_path__ + "static/media/businessCasesPreparation.5ac1a9d6.jpg";